import { get } from '@/api/implementation/app';

export const autocomplete = (action) => {
  return get('/mapper/autocomplete', {params: {action}});
};
